/**
 * Auth token management
 *
 * Stores Auth0's getAccessTokenSilently function reference so RTK Query can get fresh tokens on each request, avoiding stale token issues.
 */

let getAccessTokenSilently = null

export const setAuthGetter = fn => {
	getAccessTokenSilently = fn
}

export const getToken = async () => {
	if (!getAccessTokenSilently) {
		throw new Error('Auth not initialized')
	}
	return getAccessTokenSilently()
}
